/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import NotFoundPage from 'containers/NotFoundPage/Loadable';
import LowestStorageListPage from './LowestStorageListPage/Loadable';

function index() {
  const profile = localStorage.getItem('profile')
    ? JSON.parse(localStorage.getItem('profile'))
    : {};
  const { type } = profile;
  if (type === 'frontline' || type === 'manager') {
    return <Redirect to="/not-found" />;
  }
  return (
    <React.Fragment>
      <Switch>
        <Route exact path="/lowestStorage" component={LowestStorageListPage} />
        <Route component={NotFoundPage} />
      </Switch>
    </React.Fragment>
  );
}

export default index;
